var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('video-background',{staticStyle:{"height":"100vh"},attrs:{"src":"/AmpersandLogo720p.mp4","poster":"/libretto_poster.jpg","overlay":"linear-gradient(45deg,#ffffff30,#9999996b)"}},[_c('HelloWorld')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }